module.exports = __webpack_public_path__ + "media/flags/bz-73089ddb.svg";